export const ProcssType = {
    CHANGE_PLAN: 'CHANGE_PLAN',
    OWNERSHIP_TRANSFER: 'OWNERSHIP_TRANSFER',
    CHANGE_NUMBER: 'CHANGE_NUMBER',
    
}

export const ProcessTypeTitles = {
    [ProcssType.CHANGE_PLAN]: 'לא ניתן לבצע החלפת תוכנית חיוב לקו זה',
    [ProcssType.OWNERSHIP_TRANSFER]: 'לא ניתן לבצע העברת בעלות לקו זה',
    [ProcssType.CHANGE_NUMBER]: 'לא ניתן לבצע החלפת מספר לקו זה',
} as const;